import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const NAV = [
  { label: '표지', to: '/' },
  { label: '책 읽기', to: '/read?page=1' },
  { label: '소개', to: '/about' },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-40 w-full border-b border-primary-800/60 bg-primary-900/95 backdrop-blur">
      <div className="mx-auto flex h-16 w-full items-center justify-between px-4 md:h-[68px] md:px-10">
        <Link to="/" className="flex items-center gap-3">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
            <i className="ri-book-2-line text-lg" aria-hidden="true"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold text-background-50">봉사의 길</span>
            <span className="mt-0.5 text-[11px] font-label tracking-wide text-accent-300">
              세창 박종윤 사진 자서전
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-2 md:flex">
          {NAV.map((item) => {
            const active =
              item.to === '/'
                ? location.pathname === '/'
                : location.pathname.startsWith(item.to.split('?')[0]);
            return (
              <Link
                key={item.to}
                to={item.to}
                className={`whitespace-nowrap rounded-md px-4 py-2 text-base font-label transition-colors ${
                  active
                    ? 'bg-primary-700 text-background-50'
                    : 'text-primary-100 hover:bg-primary-800 hover:text-background-50'
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? '메뉴 닫기' : '메뉴 열기'}
          aria-expanded={open}
          className="flex h-11 w-11 items-center justify-center rounded-md text-background-50 md:hidden"
        >
          <i className={open ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'} aria-hidden="true"></i>
        </button>
      </div>

      {open && (
        <nav className="flex flex-col gap-1 border-t border-primary-800/60 bg-primary-900 px-4 pb-4 pt-2 md:hidden">
          {NAV.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              onClick={() => setOpen(false)}
              className="flex min-h-[44px] items-center rounded-md px-4 text-base font-label text-primary-100 hover:bg-primary-800 hover:text-background-50"
            >
              {item.label}
            </Link>
          ))}
        </nav>
      )}
    </header>
  );
}